var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "c-menuConversion m-menuHeader" },
    [
      _c("header-logo", {
        staticClass: "m-menuHeader_logo m-menuHeader_logo--startingTablet",
        attrs: { "large-mode": true },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "m-menuHeader_button m-menuHeader_button--burger m-menuHeader_button--untilTablet",
          on: {
            click: function ($event) {
              return _vm.showMenuMobile()
            },
          },
        },
        [
          _c(
            "svg",
            {
              class: "m-menuHeader_icon",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "20",
                height: "17",
                viewBox: "0 0 20 17",
                "svg-inline": "",
                role: "presentation",
                focusable: "false",
                tabindex: "-1",
              },
            },
            [
              _c("g", { attrs: { fill: "#8e8e93" } }, [
                _c("path", {
                  attrs: { d: "M0 0h20v3H0zM0 7h20v3H0zM0 14h20v3H0z" },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "m-menuHeader_text" }, [_vm._v("menu")]),
        ]
      ),
      _vm._v(" "),
      _c("header-logo", {
        staticClass: "m-menuHeader_logo m-menuHeader_logo--untilTablet",
        attrs: { "large-mode": true },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "m-menuHeader_link m-menuHeader_link--startingTablet m-menuHeader_link--provider",
          class: _vm.expandedStyle("category"),
          attrs: {
            role: "button",
            tabindex: "0",
            title: "Qual serviço ou produto você precisa?",
          },
          on: {
            click: function ($event) {
              return _vm.toggleMenu("category")
            },
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.toggleMenu("category")
            },
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "m-menuHeader_text m-menuHeader_text--untilDesktop",
            },
            [_vm._v("Pedir orçamentos")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "m-menuHeader_text--startingDesktop" }, [
            _vm._v("Pedir orçamentos"),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              class:
                "m-menuHeader_icon m-menuHeader_icon--shop m-menuHeader_iconArrow",
              attrs: {
                width: "16",
                height: "9",
                viewBox: "0 0 16 9",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "svg-inline": "",
                role: "presentation",
                focusable: "false",
                tabindex: "-1",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M.72 1.15L8 8.432l7.28-7.28L14.22.09 8 6.31 1.78.09.72 1.15z",
                  fill: "#000",
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass:
            "m-menuHeader_link m-menuHeader_link--startingTablet m-menuHeader_link--provider",
          attrs: { href: _vm.supplierUrl },
        },
        [
          _c(
            "span",
            {
              staticClass: "m-menuHeader_text",
              attrs: {
                title: "Veja os depoimentos de quem já usou o CoteiBem",
              },
            },
            [_vm._v("Seja um fornecedor")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass:
            "m-menuHeader_link m-menuHeader_link--startingTablet m-menuHeader_link--provider",
          attrs: { href: _vm.supportUrl },
        },
        [
          _c(
            "span",
            {
              staticClass: "m-menuHeader_text",
              attrs: { title: "Problemas? Conte com a equipe do CoteiBem" },
            },
            [_vm._v("FAQ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "m-menuHeader_button m-menuHeader_button--quotation",
          attrs: { role: "button", href: _vm.loginUrl, tabindex: "0" },
        },
        [
          _c(
            "svg",
            {
              class: "m-menuHeader_icon m-menuHeader_icon--shop",
              attrs: {
                width: "22",
                height: "22",
                viewBox: "0 0 22 22",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "svg-inline": "",
                role: "presentation",
                focusable: "false",
                tabindex: "-1",
              },
            },
            [
              _c("path", {
                attrs: {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M11 11.45a3.975 3.975 0 100-7.95 3.975 3.975 0 000 7.95zm2.475-3.975a2.475 2.475 0 11-4.95 0 2.475 2.475 0 014.95 0z",
                  fill: "#00665D",
                },
              }),
              _c("path", {
                attrs: {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M16.87 19.707A10.49 10.49 0 0021.5 11C21.5 5.201 16.799.5 11 .5S.5 5.201.5 11A10.494 10.494 0 0011 21.5a10.471 10.471 0 005.87-1.793zM11 20a8.964 8.964 0 003.975-.923v-.393c0-2.333-1.732-4.159-3.975-4.159-2.242 0-3.975 1.826-3.975 4.16v.392A8.964 8.964 0 0011 20zm0-6.975c2.962 0 5.206 2.285 5.453 5.136a9 9 0 10-10.905 0c.246-2.851 2.49-5.136 5.452-5.136z",
                  fill: "#00665D",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "m-menuHeader_text m-menuHeader_text--untilDesktop",
            },
            [_vm._v("Entrar")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "m-menuHeader_text--startingDesktop" }, [
            _vm._v("Entrar"),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }